import { render, staticRenderFns } from "./OauthError.vue?vue&type=template&id=b6710518"
import script from "./OauthError.vue?vue&type=script&lang=js"
export * from "./OauthError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports